import { RefObject } from 'react';
import {
  FIRST_COMPARE_MODEL_ANCHOR,
  SECOND_COMPARE_MODEL_ANCHOR,
} from 'src/constants';
import { ChatThreadModelSelector } from '../../../ChatThreadModelSelector';
import { CompareModeNavButton } from '../CompareModeNavButton';
import styles from './CompareModeColumn.module.scss';
import { useBreakpoint, useRightSidePanelState } from 'src/hooks';
import classNames from 'classnames';
import { MessageListContainer } from '../../../MessageListContainer';
import { VirtuosoMessageListMethods } from '@virtuoso.dev/message-list';
import { CompareModeType, Message } from 'src/types';

interface CompareModeColumnProps {
  onComparingModelChange: (value?: string) => void;
  toggleCurrentColumn: () => void;
  compareModel?: string;
  conversationId?: string | null;
  currentDisplayedColumn: string | null;
  messageListRef: RefObject<VirtuosoMessageListMethods<Message>>;
  compareType: CompareModeType;
}

export const CompareModeColumn = ({
  compareModel,
  conversationId,
  currentDisplayedColumn,
  messageListRef,
  toggleCurrentColumn,
  onComparingModelChange,
  compareType,
}: CompareModeColumnProps) => {
  const { isLaptopLAndUp } = useBreakpoint();
  const { isRightPanelExpanded } = useRightSidePanelState();

  const shouldDisplayAsOneColumn = isRightPanelExpanded || !isLaptopLAndUp;

  return (
    <div className={styles.root}>
      <div
        className={classNames(styles.header, {
          [styles.displayAsOneColumn]: shouldDisplayAsOneColumn,
        })}
      >
        {shouldDisplayAsOneColumn && (
          <CompareModeNavButton
            type="left"
            isDisabled={currentDisplayedColumn === FIRST_COMPARE_MODEL_ANCHOR}
            toggleCurrentColumn={toggleCurrentColumn}
          />
        )}

        <ChatThreadModelSelector
          shouldOpenExternalModelsByClick
          isComparingMode
          onComparingModelChange={onComparingModelChange}
          compareModel={compareModel}
        />

        {shouldDisplayAsOneColumn && (
          <CompareModeNavButton
            type="right"
            isDisabled={currentDisplayedColumn === SECOND_COMPARE_MODEL_ANCHOR}
            toggleCurrentColumn={toggleCurrentColumn}
          />
        )}
      </div>

      {!conversationId ? (
        <div className={styles.emptyContainer}>
          <span className={styles.caption}>
            Select your preferred AI model from the above dropdown
          </span>
        </div>
      ) : (
        <MessageListContainer
          conversationId={conversationId}
          messageListRef={messageListRef}
          compareType={compareType}
        />
      )}
    </div>
  );
};
